'use strict';

export default class ListController {

  /*@ngInject*/
  constructor($http, $state) {
    this.$http = $http;
    this.$state = $state;
  }

  $onInit() {

    this.getTemplates();
  }

  getTemplates() {
    this.$http.get('/api/writeTemplates').then(res => {
      this.templates = res.data;
    });
  }

  delete(id) {
    if (confirm("确定？")) {
      this.$http.delete('api/writeTemplates/' + id).then(response => {
        this.getTemplates();
      });
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/writeTpl/list/list.controller.js